import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./FAQ.css";

const FAQ = () => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleToggle = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const faqData = [
    {
      category: "General",
      questions: [
        {
          id: "general1",
          question: "What is LICO?",
          answer:
            "LICO (Learn and Innovate Technologies Limited) is a multi-faceted enterprise offering four core services: Business and Tech Training, Entrepreneurship Development, Sustainable Energy Solutions (Solar), and Real Estate & Construction Services. We empower individuals and businesses through education, technology, sustainability, and strategic investments.",
        },
        {
          id: "general2",
          question: "Where is LICO located?",
          answer:
            "LICO operates across Nigeria, with services available in major cities. Our training programs can be delivered both in-person and online, while our solar installations and real estate services are provided on-site based on client location.",
        },
        {
          id: "general3",
          question: "How can I get started with LICO's services?",
          answer:
            "You can get started by contacting us through our website's contact form, calling our phone line, or sending us an email. Our team will schedule a consultation to understand your needs and recommend the best solutions for you.",
        },
      ],
    },
    {
      category: "Training Programs",
      questions: [
        {
          id: "training1",
          question: "What types of training programs does LICO offer?",
          answer:
            "We offer comprehensive training in Business & Leadership Skills, Technical & IT Training (Web Development, Data Science, Cloud Computing), Entrepreneurship Programs, Digital Marketing, Financial Management, and Professional Development courses tailored to industry needs.",
        },
        {
          id: "training2",
          question: "Are the training programs available online?",
          answer:
            "Yes! We offer both in-person and online training options. Our online programs feature live interactive sessions, recorded lectures for flexible learning, hands-on projects, and one-on-one mentorship to ensure you get the same quality education remotely.",
        },
        {
          id: "training3",
          question:
            "Do I receive a certificate after completing a training program?",
          answer:
            "Absolutely! Upon successful completion of any training program, you'll receive an industry-recognized certificate from LICO. Our certificates demonstrate your competency in the subject matter and can enhance your professional portfolio.",
        },
        {
          id: "training4",
          question: "What are the payment options for training programs?",
          answer:
            "We offer flexible payment plans including full upfront payment (with discounts), installment plans, and corporate training packages. We accept bank transfers, card payments, and mobile money transfers for your convenience.",
        },
      ],
    },
    {
      category: "Entrepreneurship Support",
      questions: [
        {
          id: "entrepreneur1",
          question: "How does LICO support aspiring entrepreneurs?",
          answer:
            "We provide comprehensive entrepreneurship support including business advisory services, startup guidance, growth strategy development, mentorship programs, funding support connections, and business plan development assistance to help you launch and scale successfully.",
        },
        {
          id: "entrepreneur2",
          question: "Can LICO help me develop a business plan?",
          answer:
            "Yes! Our business advisory team specializes in creating comprehensive, investor-ready business plans. We'll work with you to develop your business model, financial projections, market analysis, and growth strategies.",
        },
        {
          id: "entrepreneur3",
          question:
            "Do you provide ongoing mentorship after the initial consultation?",
          answer:
            "Yes, we offer ongoing mentorship packages where experienced entrepreneurs and business professionals provide continuous guidance, accountability, and strategic advice as your business grows and evolves.",
        },
      ],
    },
    {
      category: "Solar Energy Solutions",
      questions: [
        {
          id: "solar1",
          question: "What solar energy services does LICO provide?",
          answer:
            "We offer complete solar solutions including system design and consultation, professional installation, maintenance and support services, energy audits, cost-benefit analysis, and both residential and commercial solar installations.",
        },
        {
          id: "solar2",
          question: "How long does a solar installation take?",
          answer:
            "Installation timelines vary based on system size and complexity. Residential installations typically take 1-3 days, while commercial projects may take 1-2 weeks. We provide a detailed timeline during the consultation phase.",
        },
        {
          id: "solar3",
          question: "Do you provide maintenance for solar systems?",
          answer:
            "Yes! We offer comprehensive maintenance packages including regular system inspections, cleaning, performance monitoring, troubleshooting, and repairs. Our maintenance plans ensure your solar system operates at peak efficiency.",
        },
        {
          id: "solar4",
          question: "What is the return on investment for solar energy?",
          answer:
            "ROI varies based on system size, energy consumption, and location. Most clients see significant savings on electricity bills within the first year, with complete ROI typically achieved within 3-5 years. We provide detailed ROI analysis during consultation.",
        },
        {
          id: "solar5",
          question: "Do you offer financing options for solar installations?",
          answer:
            "Yes, we provide flexible payment plans and can connect you with financing partners to make solar energy accessible. Options include installment payments, leasing arrangements, and full purchase with extended payment terms.",
        },
      ],
    },
    {
      category: "Real Estate Services",
      questions: [
        {
          id: "realestate1",
          question: "What real estate services does LICO offer?",
          answer:
            "We provide comprehensive real estate services including property sales and acquisition, investment advisory, construction services, development consulting, property management, land documentation assistance, and real estate portfolio management.",
        },
        {
          id: "realestate2",
          question: "Can LICO help me find investment properties?",
          answer:
            "Absolutely! Our real estate investment advisory team helps clients identify lucrative investment opportunities, conduct due diligence, analyze potential returns, and complete transactions. We focus on properties with strong appreciation potential and rental income opportunities.",
        },
        {
          id: "realestate3",
          question:
            "Do you assist with property documentation and legal processes?",
          answer:
            "Yes, we guide clients through the entire documentation process including land verification, title perfection, survey plans, Governor's Consent, and all necessary legal procedures to ensure secure property transactions.",
        },
        {
          id: "realestate4",
          question: "Does LICO provide construction services?",
          answer:
            "Yes! Our construction division handles residential and commercial building projects from foundation to finishing. We provide project management, quality control, and timely delivery while maintaining competitive pricing.",
        },
      ],
    },
    {
      category: "Pricing & Payment",
      questions: [
        {
          id: "pricing1",
          question: "How much do LICO's services cost?",
          answer:
            "Pricing varies based on the specific service, scope, and customization required. Training programs start from affordable rates with discounts for early registration. Solar installations are quoted after site assessment. Real estate services are commission-based. Contact us for detailed pricing.",
        },
        {
          id: "pricing2",
          question: "Do you offer discounts for corporate clients?",
          answer:
            "Yes! We provide special corporate packages and volume discounts for businesses training multiple employees, large-scale solar installations, and bulk real estate transactions. Contact our corporate services team for custom quotes.",
        },
        {
          id: "pricing3",
          question: "What payment methods do you accept?",
          answer:
            "We accept bank transfers, card payments (debit/credit), mobile money transfers, and online payment platforms. For large projects, we can accommodate staged payments aligned with project milestones.",
        },
      ],
    },
  ];

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="faq-hero-particles"></div>
        <div className="faq-hero-content">
          <div className="faq-hero-tag">SUPPORT CENTER</div>
          <h1 className="faq-hero-title">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h1>
          <p className="faq-hero-description">
            Find answers to common questions about LICO's training programs,
            solar energy solutions, real estate services, and entrepreneurship
            support. Can't find what you're looking for? Contact our team
            directly.
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content">
        <div className="container">
          {faqData.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <div className="faq-category-header">
                <span className="category-chip">{category.category}</span>
                <h2 className="category-title">{category.category}</h2>
              </div>

              <div className="faq-accordion-container">
                {category.questions.map((faq) => (
                  <div
                    key={faq.id}
                    className={`faq-accordion ${
                      expandedId === faq.id ? "expanded" : ""
                    }`}
                  >
                    <button
                      className="faq-accordion-header"
                      onClick={() => handleToggle(faq.id)}
                      aria-expanded={expandedId === faq.id}
                    >
                      <span className="faq-question">{faq.question}</span>
                      <ExpandMoreIcon
                        className={`faq-icon ${
                          expandedId === faq.id ? "rotated" : ""
                        }`}
                      />
                    </button>
                    <div className="faq-accordion-content">
                      <div className="faq-answer">{faq.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact CTA */}
      <section className="faq-cta">
        <div className="faq-cta-content">
          <h2 className="faq-cta-title">Still Have Questions?</h2>
          <p className="faq-cta-description">
            Our team is here to help! Reach out to us and we'll get back to you
            within 24 hours.
          </p>
          <div className="faq-cta-buttons">
            <a href="#contact" className="btn btn-primary">
              Contact Us
            </a>
            <a href="tel:+2349078801125" className="btn btn-secondary">
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
